import {
  registerDecorator,
  type ValidationOptions,
  type ValidationArguments,
} from 'class-validator';

/**
 * Validates that a value is either empty or a valid URL.
 * Ensures only legitimate URLs can be saved to prevent malicious strings.
 */
export function IsEmbedUrl(validationOptions?: ValidationOptions) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isEmbedUrl',
      target: object.constructor,
      propertyName: propertyName,
      options: validationOptions,
      validator: {
        validate(value: unknown) {
          if (typeof value !== 'string') {
            return false;
          }
          // Empty string is valid (means no URL set)
          if (!value.trim()) {
            return true;
          }
          // Validate URL format
          try {
            const url = new URL(value);
            // Only allow http and https protocols
            return url.protocol === 'http:' || url.protocol === 'https:';
          } catch {
            return false;
          }
        },
        defaultMessage(args: ValidationArguments) {
          return `${args.property} must be a valid HTTP or HTTPS URL`;
        },
      },
    });
  };
}
